import type { ToastFunctionOptions } from 'svoast';

import { Loc } from '$lib/tools/locale.svelte';
import { toast as toast_variable } from 'svoast';

export const toast = {
   success: (message: string, options?: ToastFunctionOptions) => {
      try {
         toast_variable.success(Loc(message), { closable: true, ...options });
         toast.show_notifications_popover()
      } catch (error) {
         console.error('error at toast success', { error })
      }
   },
   error: (message: string, options?: ToastFunctionOptions) => {
      try {

         toast_variable.error(Loc(message), { closable: true, duration: 2000, ...options });
         toast.show_notifications_popover()
      } catch (error) {
         console.error('error at toast error', { error })
      }
   },
   warning: (message: string, options?: ToastFunctionOptions) => {
      try {
         toast_variable.warning(Loc(message), { closable: true, ...options });
         toast.show_notifications_popover()
      } catch (error) {
         console.error('error at toast warning', { error })
      }
   },
   info: (message: string, options?: ToastFunctionOptions) => {
      try {
         toast_variable.info(Loc(message), { closable: true, ...options });
         toast.show_notifications_popover()
      } catch (error) {
         console.error('error at toast info', { error })
      }
   },
   show_notifications_popover: () => {
      if (toast_variable.toasts.length) {
         const popover = document.getElementById("popover-toast");
         popover?.showPopover?.()
      }
      else {
         const popover = document.getElementById("popover-toast");
         popover?.hidePopover?.()
      }
   }
}
